// hooks/useLoginFlow.js
import { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../slices/configSlice";

const useLoginFlow = (setLoading) => {
  const { authState, oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();
  const { External } = useSelector((store) => store.config);

  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [checkBox, setCheckBox] = useState(false);

  const login = async () => {
    setLoading(true);
    await oktaAuth.signInWithRedirect();
  };

  useEffect(() => {
    dispatch(setConfig(null));
  }, []);

  useEffect(() => {
    if (authState && External !== null) {
      login();
    }
  }, [External]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrors({});
    setCheckBox(false);
  };

  const switchToInternal = () => dispatch(setConfig(false));
  const switchToExternal = () => dispatch(setConfig(true));

  return {
    open,
    handleOpen,
    handleClose,
    errors,
    setErrors,
    checkBox,
    setCheckBox,
    switchToInternal,
    switchToExternal,
  };
};

export default useLoginFlow;
